import { useContext, useState } from "react";
// import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
// import Modal from 'react-modal';
// import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { refeshPend } from "../../../App";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import '../../Admin Master/Transport Master/modemaster.css';
// import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";


function ScanByReffNo() {

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [getScan, setGetScan] = useState([]);
    // const [openRow, setOpenRow] = useState(null);
    const [docket, setDocket] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    // const [selectAll, setSelectAll] = useState(false);
    const [selectedScanRows, setSelectedScanRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    // const [searchQuery, setSearchQuery] = useState('');
    const { hubFun } = useContext(refeshPend);
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState(firstDayOfMonth);
    const [toDate, setToDate] = useState(today);
    const statusOptions = [
        { value: "Arrived", label: "Arrived" },
        // (maybe you meant "Return"?)
    ];
    const [formData, setFormData] = useState({
        DocketNo: [],
        Inscan_Status: "Arrived",
        Inscan_Remark: "",
        docketNo: "",
        masterAwbNo: "",
    })







    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };



    const handleFind = async () => {
        const ref = String(formData.docketNo)
            .trim()
            .replace(/\r|\n/g, "");

        const mas = String(formData.Inscan_Remark)
            .trim()
            .replace(/\r|\n/g, "");

        const doc = String(docket)
            .trim()
            .replace(/\r|\n/g, "");

        if (!ref || !mas || !doc) {
            Swal.fire({
                icon: "warning",
                title: "Warning!",
                text: "Master No, Awb No and Reff No are required!"
            });
            return;
        }

        // ✅ Duplicate check based on Ref No
        const isDuplicate = selectedScanRows.some(
            row => row.Ref_No === ref
        );

        if (isDuplicate) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate!",
                text: `Reff No ${ref} already added.`
            });

            setFormData(prev => ({
                ...prev,
                docketNo: ""
            }));
            return;
        }

        try {
            setLoading(true);

            const response = await getApi(
                `/Inscan/getBankImportData?Branch_Code=${JSON.parse(localStorage.getItem("Login"))?.Branch_Code}&MasterAwbno=${mas}&RefNo=${ref}`
            );



            const found = response.data?.[0];

            if (!found) {
                Swal.fire({
                    icon: "error",
                    title: "Not Found!",
                    text: `Reff No ${ref} not exists in Master No ${mas} or this Branch ${JSON.parse(localStorage.getItem("Login"))?.Branch_Code}`
                });

                setFormData(prev => ({
                    ...prev,
                    docketNo: ""
                }));
                return;
            }



            // Generate AWB for display
            const displayAwb = Number(doc) + selectedScanRows.length;

            // Add AWB
            setSelectedDocketNos(prev => [
                ...prev,
                {
                    DocketNo: displayAwb,
                    RefNo: found.Ref_No,   // ya found.RefNo (API response ke hisab se)
                }
            ]);
            // Add Row
            setSelectedScanRows(prev => [...prev, found]);

            // Clear Reff No textbox
            setFormData(prev => ({
                ...prev,
                docketNo: ""
            }));

        } catch (error) {
            console.log(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to fetch docket."
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteRow = (refNo) => {
        Swal.fire({
            title: "Are you sure?",
            text: `Delete Ref No ${refNo}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete"
        }).then((result) => {
            if (!result.isConfirmed) return;

            const updatedRows = selectedScanRows.filter(
                row => row.Ref_No !== refNo
            );

            setSelectedScanRows(updatedRows);

            // Recalculate AWB numbers
            const newAwbs = updatedRows.map((_, index) => Number(docket) + index);

            setSelectedDocketNos(newAwbs);

            Swal.fire({
                icon: "success",
                title: "Deleted Successfully",
                timer: 1500,
                showConfirmButton: false
            });
        });
    };




    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (JSON.parse(localStorage.getItem("Login"))?.Branch_Code === "ALB") {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "You Can not scan data, please login the branch",
            });
            return;
        }

        if (selectedDocketNos.length === 0) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Please select at least one Docket No before submitting the form.",
            });
            return;
        }

        const requestPayload = {
            LocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
            Dockets: selectedDocketNos.map(item => ({
                DocketNo: String(item.DocketNo),   // <-- string
                RefNo: String(item.RefNo),
            }))
        }

        try {
        

const response = await postApi("/Booking/ImportOrderEntry", requestPayload);

if (response.SuccessCount > 0) {
    // At least one record imported successfully
    Swal.fire({
        icon: "success",
        title: "Success",
        text: "Upload Successfull", // e.g. "Import Completed With Some Errors"
    });

    // Reset form if required
    setFormData({
        Inscan_Status: "Arrived",
        Inscan_Remark: "",
        masterAwbNo: "",
        DocketNo: [],
        docketNo: "",
    });

    setSelectedRows([]);
    setSelectedDocketNos([]);
    setSelectedScanRows([]);
    setDocket("");

} else {
    // No records imported
    Swal.fire({
        icon: "error",
        title: "Import Failed",
        text: response.Failed?.[0]?.Message || response.Message,
    });
}

        } catch (error) {
            console.error("Error submitting Inscan:", error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong while generating data. Please try again.",
            });
        }
    };



    return (
        <div className="body">

            <div className="container1">
                <form action="" onSubmit={handleSubmit}>
                    <div className="fields2">
                        {/* <div className="input-field3">
                            <label>Master Awb No</label>
                            <input type="text"
                                className="input" placeholder="Enter Master Awb No" value={formData.masterAwbNo}
                                onChange={(e) => setFormData({ ...formData, masterAwbNo: e.target.value })} />
                        </div> */}
                        {/* <div className="input-field3">
                            <label>Status</label>
                            <Select
                                options={statusOptions}
                                value={statusOptions.find(opt => opt.value === formData.Inscan_Status) || null}
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        Inscan_Status: selectedOption ? selectedOption.value : ""
                                    })
                                }
                                placeholder="Select Status"
                                required
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />
                        </div> */}



                        <div className="input-field3">
                            <label>Master Awb No</label>
                            <input type="text"
                                className="input" placeholder="Enter Master Awb No" value={formData.Inscan_Remark}
                                onChange={(e) => setFormData({ ...formData, Inscan_Remark: e.target.value })} />
                        </div>


                        <div className="input-field3">
                            <label>Awb No</label>
                            <input type="number"
                                className="input" placeholder="Awb No" value={docket}
                                onChange={(e) => setDocket(e.target.value)} />
                        </div>



                        <div className="input-field3">
                            <label>Reff No</label>
                            <input

                                type="text"
                                className="input"
                                placeholder="Enter Reff No"
                                autoFocus
                                value={formData.docketNo}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        docketNo: e.target.value
                                    })
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stop form submit
                                        handleFind();       // auto call after scan
                                    }
                                }}
                            />
                        </div>





                        <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                            <button className="ok-btn" type="submit" style={{ width: "70px" }}>Submit</button>
                            <button type="button" className="ok-btn" style={{ width: "70px" }}>Cancel</button>
                        </div>
                    </div>
                </form>


                <div className="table-container">
                    <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                        <thead className="table-sm">
                            <tr>
                                <th className="w-60">Action</th>
                                <th className="w-60">Sr.No</th>
                                <th >Awb No</th>
                                <th >Reff No</th>
                                <th >Consignee Name</th>
                                <th> Pin Code</th>
                                <th >Destination</th>
                                <th> Pin Code</th>
                                <th >QTY</th>
                                <th >Weight</th>
                                <th >Customer Name</th>
                                <th> Book Date</th>


                            </tr>
                        </thead>
                        <tbody>
                            {
                                selectedScanRows.map((scan, index) => (

                                    <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                        <td><button onClick={() => {
                                            handleDeleteRow(scan?.Ref_No);

                                        }} className='edit-btn'>
                                            <i className='bi bi-trash'></i></button></td>
                                        <td className="w-60">{index + 1}</td>
                                        <td>{selectedDocketNos[index]?.DocketNo}</td>
                                        <td>{scan?.Ref_No}</td>
                                        <td>{scan.ConsigneeName}</td>
                                        <td>{scan.CityPincode}</td>
                                        <td>{scan.CityName}</td>
                                        <td>{scan.OriginName}</td>

                                        <td>{scan.Qty}</td>
                                        <td>{scan.ActualWt}</td>
                                        <td>{scan.CustomerName}</td>
                                        <td>{scan.BookDate}</td>


                                    </tr>


                                ))}
                        </tbody>
                    </table>
                </div>




            </div>
        </div>
    );
};


export default ScanByReffNo;